<template>
  <div>
    <div class="map-box" id="map" ref="map"></div>
    <div class="ol-popup" ref="pickUpPoint">
      <div class="closebtn" @click="initActiveIcon('pickUpPoint')">
        <img src="@/assets/img/remove.svg" alt="" />
      </div>
      <div class="popup-content" ref="pickUpContent" @click="handleView"></div>
      <!-- <div class="navigation" @click="callNative('pickUpPoint')">
        <img src="@/assets/img/navigation.svg" alt="" /> <span>导航</span>
      </div> -->
    </div>
    <div class="ol-popup" ref="endPoint">
      <div class="closebtn" @click="initActiveIcon('endPoint')">
        <img src="@/assets/img/remove.svg" alt="" />
      </div>
      <div class="popup-content" ref="endContent" @click="handleView"></div>
      <!-- <div class="navigation" @click="callNative('endPoint')">
        <img src="@/assets/img/navigation.svg" alt="" /> <span>导航</span>
      </div> -->
    </div>

    <!-- 送货司机位置 -->
    <div class="ol-popup" ref="sijiPoint">
      <div class="closebtn" @click="initActiveIcon('sijiPoint')">
        <img src="@/assets/img/remove.svg" alt="" />
      </div>
      <div class="popup-content" ref="sijiContent" @click="handleView"></div>
      <!-- <div class="navigation" @click="callNative('sijiPoint')">
        <img src="@/assets/img/navigation.svg" alt="" /> <span>导航</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { coordinateConversion, getZoom } from "@/utils/util";
import { ORDER_STATUS } from "@/utils/constant";
// import { getAction } from '@/api/manage'
import dayjs from "dayjs";
import $ from "jquery";

export default {
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      orderId: "",
      mainJS: {},
      orderData: {},
      drivingData: {},
      drivingList: [],
      driverData: {},
      eventVectorSource: null,
      assetsSources: null,
      pickupSources: null,
      myPosition: null,
      pickUpPoint: null,
      endPoint: null,
      sijiPoint: null,
      driverAddress: "",
      url: {
        order: "/order/api/order/",
      },
      lineType: "",
      zoom: 17,
      masterAddress: "",
      distanceTihuo: {},
      distanceKehu: {},
      currentTime: "", // 当前时间
      pointList: [],
      statusValue: 0,
    };
  },
  watch: {
    orderInfo: {
      handler(value) {
        this.$nextTick(() => {
          this.orderId = value.id;
          // this.getOrderInfo(value.id);
          // this.setMap();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 跳转导航
    callNative(type) {
      let origin = `${this.orderData.lat},${this.orderData.lng}`;
      let destination = `${this.orderData.orderExpand.pickUpLat},${this.orderData.orderExpand.pickUpLng}`;
      // 送货司机的位置
      let driver = `${this.orderData.pickupWorkerLng},${this.orderData.pickupWorkerLat}`;
      let json = "";
      if (type == "pickUpPoint") {
        json = JSON.stringify({
          name: "toNavigation",
          param: { ll: destination, address: this.orderData.pickupAddress },
        });
      } else if (type == "sijiPoint") {
        json = JSON.stringify({
          name: "toNavigation",
          param: { ll: driver, address: this.driverAddress },
        });
      } else {
        json = JSON.stringify({
          name: "toNavigation",
          param: { ll: origin, address: this.orderData.address },
        });
      }
    },
    // 获取订单详情
    getOrderInfo() {
      this.$fetch(this.url.order + this.orderId).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.currentTime =
            res.data.currentTime ||
            dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
          res.data.childOrder = res.data.childOrder || {};

          // 客户地址
          let origin = `${res.data.lng},${res.data.lat}`;
          // 提货点
          let destination = `${res.data.orderExpand.pickUpLng},${res.data.orderExpand.pickUpLat}`;
          // 师傅位置
          // let mylocation = `${this.$route.query.lng},${this.$route.query.lat}`
          let mylocation = ``;
          // if(res.data.orderType=='GENERAL'){
          //   mylocation=`${res.data.pickupWorkerLng},${res.data.pickupWorkerLat}`
          // }
          let driver = ``;
          if (res.data.childOrderExpand.signInLat) {
            driver = `${res.data.childOrderExpand.signInLng},${res.data.childOrderExpand.signInLat}`;
            res.data.pickupWorkerLastLocationTime =
              res.data.childOrder.signInTime;
          } else if (
            res.data.orderExpand.signInLat &&
            !res.data.childOrder.status
          ) {
            driver = `${res.data.orderExpand.signInLng},${res.data.orderExpand.signInLat}`;
            res.data.pickupWorkerLastLocationTime = res.data.signInTime;
          } else {
            driver = `${res.data.pickupWorkerLng},${res.data.pickupWorkerLat}`;
          }

          let statusValue = ORDER_STATUS[res.data.status].value;
          this.statusValue = ORDER_STATUS[res.data.status].value;
          console.log(statusValue);
          // 有提货费
          if (
            res.data.orderExpand.isJishiTihuoFei ||
            res.data.childOrderExpand.isJishiTihuoFei ||
            res.data.isNeedTakeDelivery
          ) {
            // 待提货之前的状态，需要展示路经，点
            // if (statusValue <= 4) {
            this.setMapPath(destination, origin, "end");
            // this.setMapPath(mylocation, origin, "pickup");
            // } else if (statusValue >= 5 && statusValue < 8) {
            // }
            //  else if (statusValue >= 5) {
            //   console.log(1);
            //   this.setMapPath(mylocation, origin, "end");
            // } else {
            //   // this.mainJS.map.getView().animate({
            //   //   zoom: 11,
            //   //   center: coordinateConversion(origin.split(','), 4326, 3857),
            //   //   duration: '500',
            //   // })
            // }
            this.setPoint(mylocation, destination, origin);
          } else {
            // if (statusValue < 8) {
            this.setMapPath(mylocation, origin, "end");
            // } else {
            //   // this.mainJS.map.getView().animate({
            //   //   zoom: 11,
            //   //   center: coordinateConversion(origin.split(','), 4326, 3857),
            //   //   duration: '500',
            //   // })
            // }
            this.setPoint(mylocation, "", origin);
          }
          this.orderData = res.data;
          if (res.data.pickupWorkerLng) {
            console.log(driver);
            this.getAddress(driver);
            this.setDriver(driver);
            this.getDistance(
              this.orderData.status == "WAIT_PICK_UP" ||
                this.orderData.childOrder.status == "WAIT_PICK_UP"
                ? destination
                : origin,
              driver
            );
          }
          // 设置层级,位置
          this.mainJS.map.getView().animate({
            zoom: 11,
            center: coordinateConversion(
              [this.orderData.lng, this.orderData.lat],
              4326,
              3857
            ),
            duration: "500",
          });
        }
      });
    },
    // 地址解析
    getAddress(lnglat) {
      let _this = this;
      // 师傅位置
      let mylocation = lnglat;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        location: mylocation,
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        url: "https://restapi.amap.com/v3/geocode/regeo",
        success: function (res) {
          console.log(res);
          if (res.info == "OK") {
            _this.driverAddress = res.regeocode.formatted_address;
          }
        },
      });
    },
    initActiveIcon(type) {
      if (type == "pickUpPoint" && this.pickUpPoint)
        this.pickUpPoint.setPosition(undefined);
      if (type == "endPoint" && this.endPoint)
        this.endPoint.setPosition(undefined);
      if (type == "sijiPoint" && this.sijiPoint)
        this.sijiPoint.setPosition(undefined);
    },
    clearALL() {
      if (this.pickUpPoint) this.pickUpPoint.setPosition(undefined);
      if (this.endPoint) this.endPoint.setPosition(undefined);
      if (this.sijiPoint) this.sijiPoint.setPosition(undefined);
    },
    handleView() {
      console.log(111);
    },
    setOffset(type) {
      // setTimeout(() => {
      console.log(this.$refs[type].clientWidth);
      console.log(this.$refs[type].clientHeight);
      let x = this.$refs[type].clientWidth / 2;
      let y = this.$refs[type].clientHeight + 25;
      console.log(x);
      console.log(y);
      if (type == "pickUpPoint") this.pickUpPoint.setOffset([-x, -y]);
      if (type == "endPoint") this.endPoint.setOffset([-x, -y]);
      if (type == "sijiPoint") this.sijiPoint.setOffset([-x, -y]);
      // }, 500)
    },
    // 加载地图
    setMap() {
      if (this.mainJS.map) {
        this.mainJS.map.render();
        this.removeFeature();
        this.clearALL();
        this.getOrderInfo();
        return;
      }
      this.getOrderInfo();
      let _this = this;
      this.pickUpPoint = new ol.Overlay({
        element: _this.$refs["pickUpPoint"],
        autoPan: true,
      });
      this.endPoint = new ol.Overlay({
        element: _this.$refs["endPoint"],
        autoPan: true,
      });
      this.sijiPoint = new ol.Overlay({
        element: _this.$refs["sijiPoint"],
        autoPan: true,
      });
      this.mainJS.baseMap = new ol.layer.Tile({
        source: new ol.source.XYZ({
          // url: '//webrd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
          url: "//webrd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
        }),
      });
      this.mainJS.center = coordinateConversion(
        [104.047244, 30.543346000000014],
        4326,
        3857
      );
      console.log(this.mainJS.center);
      //视图
      this.mainJS.view = new ol.View({
        center: this.mainJS.center,
        // projection: 'EPSG:4326',
        minZoom: 5,
        maxZoom: 18,
        zoom: 10,
        //1.设置缩放级别为整数
        constrainResolution: true,
        //2.关闭无级缩放地图
        smoothResolutionConstraint: false,
      });
      //地图主体
      this.mainJS.map = new ol.Map({
        layers: [this.mainJS.baseMap],
        controls: [new ol.control.FullScreen()], //如果不设置 controls ，地图会默认设置
        overlays: [_this.pickUpPoint, _this.endPoint, _this.sijiPoint],
        view: this.mainJS.view,
        target: this.$refs.map,
      });
      _this.eventVectorSource = new ol.source.Vector();

      let selectSingleClick = new ol.interaction.Select();
      this.mainJS.map.addInteraction(selectSingleClick);
      selectSingleClick.on("select", function (e) {
        let features = e.target.getFeatures().getArray();
        if (features.length > 0) {
          // 单点
          if (features[0].values_.data) {
            let data = features[0].values_.data;
            if (data && data.callback) {
              data.callback(e, data.callbackParams, features[0], data.code);
            }
          }
        }
        this.getFeatures().clear();
      });
      console.log(this.mainJS.map);
      this.mainJS.map.on("moveend", function (e) {
        _this.zoom = _this.mainJS.map.getView().getZoom(); //获取当前地图的缩放级别
      });
    },
    isCenter(data) {
      console.log(data);
      // this.mainJS.map.getView().setCenter(data.lnglat);
      let statusValue = ORDER_STATUS[this.orderData.status].value;
      console.log(statusValue);
      // 提货完成不能点击
      // if (data.type == "pickUpPoint" && this.statusValue < 5) {
      if (data.type == "pickUpPoint") {
        this.pickUpPoint.setOffset([-171, -81]);
        // let el = `
        // <div class="distance">距离客户<span>${(
        //   this.distanceKehu.distance / 1000
        // ).toFixed(2)}km</span> 驾车预计<span>${(
        //   this.distanceKehu.duration / 60
        // ).toFixed(2)}min</span></div>
        // </div>`;
        this.$refs.pickUpContent.innerHTML = `
        <div class="base-card">
        <div class="address">${this.orderData.pickupAddress}</div>
        `;
        this.pickUpPoint.setPosition(data.lnglat);
      }
      if (data.type == "endPoint") {
        this.endPoint.setOffset([-171, -81]);
        this.$refs.endContent.innerHTML = `
        <div class="base-card">
        <div class="address">${this.orderData.address}</div>
        </div>
        `;
        this.endPoint.setPosition(data.lnglat);
      }

      if (data.type == "sijiPoint") {
        this.sijiPoint.setOffset([-171, -81]);
        let el = ``;
        if (
          this.orderData.status == "WAIT_PICK_UP" ||
          this.orderData.childOrder.status == "WAIT_PICK_UP"
        ) {
          el = `
          <div class="distance">距离提货<span>${(
            this.driverData.distance / 1000
          ).toFixed(2)}km</span> 驾车预计<span>${(
            this.driverData.duration / 60
          ).toFixed(2)}min</span></div>`;
        } else {
          el = `
          <div class="distance">距离客户<span>${(
            this.driverData.distance / 1000
          ).toFixed(2)}km</span> 驾车预计<span>${(
            this.driverData.duration / 60
          ).toFixed(2)}min</span></div>`;
        }
        this.$refs.sijiContent.innerHTML = `
        <div class="base-card">
        <div class="address">${this.driverAddress}</div>
        ${
          this.orderData.childOrderExpand.signInLat ||
          (this.orderData.orderExpand.signInLat &&
            !this.orderData.childOrder.status)
            ? ""
            : el
        }
        <div class="distance">${
          this.orderData.childOrderExpand.signInLat ||
          (this.orderData.orderExpand.signInLat &&
            !this.orderData.childOrder.status)
            ? "上门签到："
            : ""
        }${dayjs(this.orderData.pickupWorkerLastLocationTime).format(
          "YYYY-MM-DD HH:mm"
        )}</div>
        </div>
        `;
        this.sijiPoint.setPosition(data.lnglat);
      }
      this.setOffset(data.type);
    },
    // 保留两位小数
    formatDecimal(num, decimal) {
      num = num.toString();
      let index = num.indexOf(".");
      if (index !== -1) {
        num = num.substring(0, decimal + index + 1);
      } else {
        num = num.substring(0);
      }
      return parseFloat(num).toFixed(decimal);
    },
    // 设置签到时间
    setSigninTime() {
      if (
        new Date(this.orderData.appointmentTime) >
        new Date(this.orderData.signInTime)
      ) {
        return `${this.orderData.signInTime}上门签到`;
      } else {
        return this.timeSubtract(
          this.orderData.signInTime,
          this.orderData.appointmentTime,
          "end"
        );
      }
    },
    // 时间相减
    timeSubtract(startDate, endDate, type) {
      console.log(startDate);
      console.log(endDate);
      if (type == "service" && !endDate) return this.setServiceTime();
      let starTime = new Date(startDate).getTime();
      let endTime = new Date(endDate).getTime();
      let time = null;
      if (startDate > endDate) time = (starTime - endTime) / 1000 / 60 / 60;
      else time = (endTime - starTime) / 1000 / 60 / 60;
      let h = parseInt(time);
      // let m = parseInt((Math.floor(time * 100) / 100).toString().split('.')[1] * 0.6)
      let m = parseInt(this.formatDecimal(time, 2).split(".")[1] * 0.6);
      console.log(h, m);
      if (startDate > endDate) {
        if (type == "end") return `超时${h}小时${m}分钟`;
        else return `已迟到${h}小时${m}分钟`;
      } else {
        return `上门剩余${h}小时${m}分钟`;
      }
    },
    // 带预约之前的时间
    setServiceTime() {
      let list = this.orderData.orderServicePeriodList;
      console.log(list);
      let today = dayjs(this.orderData.currentTime).get("date");
      let yesterdayList = [],
        todayList = [],
        tomorrowList = [];
      console.log(today);
      list.map((i) => {
        console.log(dayjs(i.date).get("date"));
        let day = dayjs(i.date).get("date");
        if (day < today) yesterdayList.push(i);
        else if (day == today) todayList.push(i);
      });
      if (yesterdayList.length == list.length) {
        return "今日上门";
      } else if (todayList.length) {
        todayList = todayList.sort((a, b) => {
          dayjs(a.date).get("date") - dayjs(b.date).get("date");
        });
        return `今日${todayList[0].startTime}-${
          todayList[todayList.length - 1].endTime
        }`;
      } else {
        list = list.sort((a, b) => {
          dayjs(a.date).get("date") - dayjs(b.date).get("date");
        });
        return `${list[0].date + list[0].startTime}-${
          list[list.length - 1].endTime
        }`;
      }
      // return '今日9:00-18:00'
    },
    setMapPath(origin, destination, type) {
      // let origin = '111.665476,40.858378'
      // let destination = '111.730220,40.858997'
      this.getPlan(origin, destination, type);
    },
    // 获取送货司机到师傅的距离
    getDistance(mylocation, driver) {
      let _this = this;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        origin: mylocation,
        destination: driver,
        extensions: "base",
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        url: "https://restapi.amap.com/v3/direction/driving",
        success: function (res) {
          console.log(res);
          if (res.info == "OK") {
            _this.driverData = res.route.paths[0];
          }
        },
      });
    },
    // 路经规划
    getPlan(origin, destination, type) {
      let _this = this;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        origin: origin,
        destination: destination,
        extensions: "base",
      };
      $.ajax({
        type: "get",
        dataType: "jsonp",
        data: params,
        url: "https://restapi.amap.com/v3/direction/driving",
        success: function (res) {
          console.log(res);
          if (res.info == "OK") {
            _this.drivingData = res.route.paths[0];
            _this.drivingList = res.route.paths[0].steps.map((i) => i.polyline);
            _this.drivingList = _this.drivingList
              .join(";")
              .split(";")
              .map((i) => {
                return coordinateConversion(
                  [i.split(",")[0], i.split(",")[1]],
                  4326,
                  3857
                );
              });
            // 完工之前的状态
            let statusValue = ORDER_STATUS[_this.orderData.status].value;
            if (statusValue >= 5 && statusValue <= 8) {
              _this.distanceTihuo = res.route.paths[0];
            }
            // 订单收取提货费
            if (type == "end") {
              _this.distanceKehu = res.route.paths[0];
              _this.setRoutePlanning(
                _this.drivingList,
                _this.drivingData.distance,
                type
              );
            }
            if (type == "pickup") {
              _this.distanceTihuo = res.route.paths[0];
              _this.setPickUpPoint(
                _this.drivingList,
                _this.drivingData.distance,
                type
              );
            }
            if (!_this.orderData.orderExpand.isJishiTihuoFei) {
              _this.distanceTihuo = res.route.paths[0];
            }
            // _this.getAddress()
          }
        },
      });
    },
    // 设置路经规划
    setRoutePlanning(gisData, distance, type) {
      // console.log(gisData);
      let _this = this;
      // this.removeFeature()
      this.assetsSources = new ol.source.Vector();
      let assetsVector = new ol.layer.Vector({
        source: _this.assetsSources,
        style: _this.styleFunction,
        // attribute: type,
      });
      _this.mainJS.map.addLayer(assetsVector);

      let polygons = new ol.geom.LineString(gisData);
      let features = new ol.Feature({
        geometry: polygons,
        data: {
          callback: function (params, callbackParams, e) {
            console.log(11111111);
          },
          callbackParams: { a: "1121" },
        },
        type: type,
      });
      // if (_this.orderData.orderType == "TIMELY")
        _this.assetsSources.addFeature(features);

      // console.log(features.getGeometry());
      // 中心点
      console.log(features.getGeometry().getFlatMidpoint());
      console.log(getZoom(distance));
      // 设置层级,位置
      this.mainJS.map.getView().animate({
        // zoom: getZoom(distance),
        center: features.getGeometry().getFlatMidpoint(),
        duration: "500",
      });
    },
    // 设置师傅位置到提货点
    setPickUpPoint(gisData, distance, type) {
      let _this = this;
      // this.removeFeature()
      this.pickupSources = new ol.source.Vector();
      let assetsVector = new ol.layer.Vector({
        source: _this.pickupSources,
        style: _this.styleFunction,
        // attribute: type,
      });
      _this.mainJS.map.addLayer(assetsVector);

      let polygons = new ol.geom.LineString(gisData);
      let features = new ol.Feature({
        geometry: polygons,
        data: {
          callback: function (params, callbackParams, e) {
            console.log(11111111);
          },
          callbackParams: { a: "1121" },
        },
        type: type,
      });
      // if (_this.orderData.orderType == "TIMELY")
        _this.pickupSources.addFeature(features);
      // console.log(features.getGeometry());
      // 中心点
      console.log(features.getGeometry().getFlatMidpoint());
      console.log(getZoom(distance));
      // 设置层级,位置
      this.mainJS.map.getView().animate({
        // zoom: getZoom(distance),
        center: features.getGeometry().getFlatMidpoint(),
        duration: "500",
      });
    },
    // 设置师傅位置Point
    setDriver(location) {
      console.log(11111111111);
      let _this = this;
      let lnglat = {
        lnglat: coordinateConversion(location.split(","), 4326, 3857),
        type: "sijiPoint",
      };
      let feature = null;
      feature = new ol.Feature({
        geometry: new ol.geom.Point(lnglat.lnglat),
        type: lnglat.type,
        data: {
          callback: function (params, callbackParams, e) {
            _this.isCenter(callbackParams);
            console.log(3333);
          },
          callbackParams: lnglat,
        },
      });
      this.eventVectorSource.addFeature(feature);
    },
    // 设置对应point
    setPoint(mylocation, destination, origin) {
      console.log([mylocation]);
      // this.mainJS.map.getView().animate({
      //   zoom: 11,
      //   center: coordinateConversion(origin.split(','), 4326, 3857),
      //   duration: '500',
      // })
      let _this = this;
      _this.pointList = [
        // { lnglat: coordinateConversion(mylocation.split(','), 4326, 3857), type: 'myPosition' },
        {
          lnglat: coordinateConversion(destination.split(","), 4326, 3857),
          type: "pickUpPoint",
        },
        {
          lnglat: coordinateConversion(origin.split(","), 4326, 3857),
          type: "endPoint",
        },
      ];
      let feature = [];
      // _this.eventVectorSource = new ol.source.Vector()
      _this.pointList.map((i, index) => {
        console.log(i);
        feature.push(
          new ol.Feature({
            geometry: new ol.geom.Point(i.lnglat),
            type: i.type,
            data: {
              callback: function (params, callbackParams, e) {
                _this.isCenter(callbackParams);
                console.log(3333);
              },
              callbackParams: i,
            },
          })
        );
      });
      _this.eventVectorSource.addFeatures(feature);
      let eventLayer = new ol.layer.Vector({
        source: _this.eventVectorSource,
        style: _this.setPointStyle,
        zIndex: 100,
        attribute: `group-name`,
      });
      _this.mainJS.map.addLayer(eventLayer);
    },
    // 设置点的样式
    setPointStyle(feature) {
      let _this = this;
      let style = new ol.style.Style({
        image: new ol.style.Icon({
          anchor: [0.5, 0.5],
          src:
            feature.values_.type == "myPosition"
              ? require("@/assets/img/loc.png")
              : feature.values_.type == "pickUpPoint"
              ? require("@/assets/img/pickup_location.svg")
              : feature.values_.type == "endPoint"
              ? require("@/assets/img/end_location.svg")
              : _this.orderData.mainOrderId
              ? require("@/assets/img/anzhuang.svg")
              : require("@/assets/img/siji.svg"),
          size: [24, 28],
          // color: "#0076ce",
        }),
      });
      return style;
    },
    // 删除地图上的数据
    removeFeature() {
      if (this.eventVectorSource) {
        this.eventVectorSource.getFeatures().map((i) => {
          this.eventVectorSource.removeFeature(i);
        });
      }
      if (this.assetsSources) {
        this.assetsSources.getFeatures().map((i) => {
          this.assetsSources.removeFeature(i);
        });
      }
    },
    styleFunction(feature, resolution) {
      // console.log(feature)
      let _this = this;
      var geometry = feature.getGeometry();
      var length = geometry.getLength(); //获取线段长度
      var radio = (50 * resolution) / length;
      var dradio = 1; //投影坐标系，如3857等，在EPSG:4326下可以设置dradio=10000
      var styles = [
        new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: feature.values_.type == "end" ? "#63CF4E" : "#3455D3",
            width: 5,
          }),
        }),
      ];
      for (var i = 0; i <= 1; i += radio) {
        var arrowLocation = geometry.getCoordinateAt(i);
        geometry.forEachSegment(function (start, end) {
          if (start[0] == end[0] || start[1] == end[1]) return;
          var dx1 = end[0] - arrowLocation[0];
          var dy1 = end[1] - arrowLocation[1];
          var dx2 = arrowLocation[0] - start[0];
          var dy2 = arrowLocation[1] - start[1];
          if (dx1 != dx2 && dy1 != dy2) {
            if (Math.abs(dradio * dx1 * dy2 - dradio * dx2 * dy1) < 0.001) {
              var dx = end[0] - start[0];
              var dy = end[1] - start[1];
              var rotation = Math.atan2(dy, dx);
              styles.push(
                new ol.style.Style({
                  geometry: new ol.geom.Point(arrowLocation),
                  image: new ol.style.Icon({
                    src: require("@/assets/img/aaa.svg"),
                    anchor: [0.75, 0.5],
                    rotateWithView: false,
                    rotation: -rotation + Math.PI,
                  }),
                })
              );
            }
          }
        });
      }
      return styles;
    },
  },
};
</script>

<style lang='scss' scoped>
.map-box {
  // width: 100vw;
  // height: 100vh;
  width: 100%;
  height: 235px;
  &/deep/.ol-control {
    padding: 0;
    button {
      width: 30px;
      height: 30px;
      font-size: 20px;
      background: #fff;
      color: #b4b7bc;
      margin: 0;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.ol-popup {
  max-width: 342px;
  padding: 8px;
  background: #fff;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 8px 0px rgba(8, 40, 76, 0.13);

  .closebtn {
    position: absolute;
    // background: #e8f1ff;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    right: -7px;
    top: -6px;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .navigation {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-left: 18px;
    height: 30px;
    &::before {
      content: "";
      position: absolute;
      background: #dfe4eb;
      height: 30px;
      width: 1px;
      left: -9px;
    }
    img {
      width: 12px;
      height: 12px;
    }
  }

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-top: 19px solid #fff;
    left: 50%;
    bottom: -10px;
    margin-left: -15px;
    margin-top: 5px;
  }
}
/deep/.base-card {
  // width: 206px;
  // height: 59px;
  box-sizing: border-box;
  cursor: pointer;
  .address {
    font-size: 13px;
    color: #5e6066;
    line-height: 17px;
    margin-bottom: 4px;
    max-width: 286px;
  }
  .distance {
    font-size: 12px;
    color: #909399;
    line-height: 16px;
    span {
      color: #3455d3;
    }
  }
}
</style>
